import * as React from "react"

const Logo = () => {
  return (
    <div>
      <svg
        className="h-12 md:h-[60px]"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 64.2 67.3"
      >
        <g>
          <path
            d="m0,48.9v13c0,3,2.4,5.4,5.4,5.4h53.4c3,0,5.4-2.4,5.4-5.4v-13H0Zm43.9,7.7c-3.1,2.9-7.2,4.7-11.8,4.7s-8.7-1.8-11.8-4.7l-.2-.2,1.9-1.9.2.1c2.6,2.4,6.1,3.9,9.9,3.9s7.3-1.5,9.9-3.9l.2-.1,1.9,1.9c-.1,0-.2.2-.2.2Z"
            style={{ fill: "#cf3c32" }}
          />
          <path
            d="m64.2,5.5c0-3-2.4-5.5-5.4-5.5H5.4C2.4,0,0,2.4,0,5.4v40.7h13.5c-3.4-1.5-5.8-4.9-5.8-8.8,0-5.3,4.3-9.7,9.7-9.7,1.6,0,3.2.4,4.5,1.1l2.8-4.6-.9-2.6c-.6-.1-1,0-2-.1-1-.2-1.1-.4-.9-1s1.3-.3,2.3-.2c1,.1,2.8-.3,3.7-.3,1.2-.1,1.6,1.1,1.6,1.1,0,0-.7.1-1.3.1s-.8,0-1.4.3c-.2.1-.3.1-.5.2l.7,2h14.8l-1.4-3.8h5.2c1.4,0,2.5,1.2,2.5,2.6s-1.2,2.6-2.6,2.6h-.2v-1.4h.2c.7,0,1.2-.5,1.2-1.2s-.5-1.2-1.2-1.2h-3.2l2.5,6.9c.8-.2,1.7-.3,2.6-.3,5.3,0,9.7,4.3,9.7,9.7,0,4-2.4,7.4-5.8,8.8h13.8l.1-40.8h0Z"
            style={{ fill: "#4a9ed6" }}
          />
          <path
            d="m36.9,37.3c0-3.9,2.4-7.3,5.8-8.8l-1-2.7-11.1,11.7c-.3.3-.7.5-1.1.5h-2.4c-.3,3.7-2.5,6.7-5.8,8.2h21.4c-3.5-1.5-5.8-4.9-5.8-8.9"
            style={{ fill: "#4a9ed6" }}
          />
          <path
            d="m22,31.2l-3.4,5.4h6.4c-.2-1.8-1-3.5-2.2-4.7-.2-.3-.5-.5-.8-.7"
            style={{ fill: "#4a9ed6" }}
          />
          <path
            d="m23.1,29.5c2.2,1.6,3.8,4.2,4,7.1h1.7l-3.5-10.7s-2.2,3.6-2.2,3.6Z"
            style={{ fill: "#4a9ed6" }}
          />
          <path
            d="m17.3,38.8c-.8,0-1.5-.7-1.5-1.5s.7-1.5,1.5-1.5h.2l3.3-5.4c-1-.5-2.2-.8-3.4-.8-2.1,0-4,.8-5.4,2.2s-2.2,3.3-2.2,5.4.9,4,2.2,5.4c1.4,1.4,3.3,2.2,5.4,2.2s4-.8,5.4-2.2c1.2-1.2,2-2.9,2.2-4.7h-6.4c-.2.6-.7.9-1.3.9"
            style={{ fill: "#4a9ed6" }}
          />
          <path
            d="m51.9,31.9c-1.4-1.4-3.3-2.2-5.4-2.2-.7,0-1.3.1-1.9.2l2.2,6c.7.1,1.3.7,1.3,1.5s-.7,1.5-1.5,1.5-1.5-.7-1.5-1.5c0-.4.2-.8.4-1l-2.2-5.9c-.8.4-1.6.9-2.2,1.5-1.4,1.4-2.2,3.3-2.2,5.4s.9,4,2.2,5.4c1.4,1.4,3.3,2.2,5.4,2.2s4-.8,5.4-2.2,2.2-3.3,2.2-5.4-.8-4.1-2.2-5.5"
            style={{ fill: "#4a9ed6" }}
          />
          <polygon
            points="30.1 36.1 30.1 36.1 40.5 24.9 26.4 24.9 30.1 36.1"
            style={{ fill: "#4a9ed6" }}
          />
        </g>
      </svg>
    </div>
  )
}

const WordMark = () => {
  return (
    <div>
      <svg
        width="240"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 244.5 35.3"
      >
        <g>
          <path
            d="m15,26.3c-1.1,1.1-3,1.8-4.9,1.8s-3.6-.5-4.9-2v9.2H0V7.6h4.9v1.9c1.4-1.6,2.9-2.2,5.1-2.2,2,0,3.8.7,4.9,1.8,2,2,2.1,5.5,2.1,8.6s0,6.6-2,8.6m-6.5-14.4c-3,0-3.4,2.5-3.4,5.8s.4,5.8,3.4,5.8,3.4-2.5,3.4-5.8-.3-5.8-3.4-5.8"
            style={{ fill: "#4e4e50" }}
          />
          <path
            d="m24.4,19.3c0,2.6,1.6,4.5,4.4,4.5,2.2,0,3.3-.6,4.6-1.9l3.1,3c-2.1,2.1-4.1,3.2-7.7,3.2-4.8,0-9.4-2.2-9.4-10.4,0-6.6,3.6-10.4,8.9-10.4,5.7,0,8.9,4.1,8.9,9.7v2.3h-12.8Zm7.3-5.6c-.6-1.2-1.7-2.1-3.4-2.1s-2.9.9-3.4,2.1c-.3.7-.4,1.3-.5,2.2h7.7c0-.9-.1-1.5-.4-2.2"
            style={{ fill: "#4e4e50" }}
          />
          <path
            d="m55.1,25.7c-1.2,1.3-3.3,2.5-6.3,2.5s-5-1.2-6.3-2.5c-1.8-1.9-2.3-4.2-2.3-7.9s.5-6,2.3-7.9c1.2-1.3,3.3-2.5,6.3-2.5s5.1,1.2,6.3,2.5c1.8,1.9,2.3,4.2,2.3,7.9s-.4,6-2.3,7.9m-3.9-12.9c-.6-.6-1.4-.9-2.4-.9s-1.8.3-2.3.9c-1.1,1.1-1.2,2.8-1.2,4.9s.1,3.9,1.2,4.9c.6.6,1.3.9,2.3.9s1.8-.3,2.4-.9c1.1-1.1,1.2-2.8,1.2-4.9s-.2-3.8-1.2-4.9"
            style={{ fill: "#4e4e50" }}
          />
          <path
            d="m75.8,26.3c-1.1,1.1-3,1.8-5,1.8s-3.6-.5-4.9-2v9.2h-5.1V7.6h4.9v1.9c1.4-1.6,2.9-2.2,5.1-2.2,2,0,3.8.7,5,1.8,2,2,2.1,5.5,2.1,8.6s-.1,6.6-2.1,8.6m-6.5-14.4c-3.1,0-3.4,2.5-3.4,5.8s.4,5.8,3.4,5.8,3.4-2.5,3.4-5.8-.3-5.8-3.4-5.8"
            style={{ fill: "#4e4e50" }}
          />
          <path
            d="m86.9,27.9c-4.2,0-5.9-2.9-5.9-5.8V.1h5.1v21.7c0,1.2.5,1.8,1.8,1.8h2v4.3h-3Z"
            style={{ fill: "#4e4e50" }}
          />
          <path
            d="m96.2,19.3c0,2.6,1.6,4.5,4.4,4.5,2.2,0,3.3-.6,4.6-1.9l3.1,3c-2.1,2.1-4.1,3.2-7.7,3.2-4.8,0-9.4-2.2-9.4-10.4,0-6.6,3.6-10.4,8.9-10.4,5.7,0,8.9,4.1,8.9,9.7v2.3h-12.8Zm7.3-5.6c-.6-1.2-1.7-2.1-3.4-2.1s-2.9.9-3.4,2.1c-.3.7-.4,1.3-.5,2.2h7.7c0-.9-.1-1.5-.4-2.2"
            style={{ fill: "#4e4e50" }}
          />
          <path
            d="m118.1,15v12.9h-4.1v-12.9h-1.7v-3.1h1.7v-2.1c0-2.3,1.5-4.7,4.8-4.7h2.4v3.5h-1.6c-1,0-1.4.5-1.4,1.5v1.8h3.1v3.1h-3.2Z"
            style={{ fill: "#8b8a8d" }}
          />
          <path
            d="m134.4,26.1c-1,1.1-2.7,2-5.1,2s-4.1-.9-5.1-2c-1.5-1.6-1.9-3.4-1.9-6.4s.4-4.9,1.9-6.4c1-1.1,2.7-2,5.1-2s4.1,1,5.1,2c1.5,1.6,1.9,3.4,1.9,6.4s-.4,4.8-1.9,6.4m-3.2-10.5c-.5-.5-1.1-.7-1.9-.7s-1.4.3-1.9.7c-.9.9-.9,2.3-.9,4s.1,3.2.9,4c.5.5,1.1.7,1.9.7s1.4-.2,1.9-.7c.9-.9.9-2.3.9-4s0-3.1-.9-4"
            style={{ fill: "#8b8a8d" }}
          />
          <path
            d="m148,15.9c-.6-.6-1.2-1-2.2-1-1.3,0-2.7.9-2.7,3.1v10h-4.1V11.4h4v1.6c.8-.9,2.4-1.8,4.2-1.8,1.6,0,2.8.4,3.9,1.6l-3.1,3.1Z"
            style={{ fill: "#8b8a8d" }}
          />
          <path
            d="m169,26.3c-1.1,1.1-3,1.8-5,1.8-2.1,0-3.7-.6-5.1-2.2v1.9h-4.9V.1h5.1v9.2c1.3-1.5,2.9-2,4.9-2s3.8.7,5,1.8c2,2,2.1,5.5,2.1,8.6s0,6.6-2.1,8.6m-6.4-14.4c-3,0-3.4,2.5-3.4,5.8s.4,5.8,3.4,5.8,3.4-2.5,3.4-5.8-.4-5.8-3.4-5.8"
            style={{ fill: "#4e4e50" }}
          />
          <path
            d="m175.8,0h5.2v4.1h-5.2V0Zm.1,7.6h5.1v20.3h-5.1V7.6Z"
            style={{ fill: "#4e4e50" }}
          />
          <polygon
            points="198.8 27.9 193.8 19.4 191.7 21.9 191.7 27.9 186.6 27.9 186.6 .1 191.7 .1 191.7 15.9 198.4 7.6 204.6 7.6 197.3 15.8 205.1 27.9 198.8 27.9"
            style={{ fill: "#4e4e50" }}
          />
          <path
            d="m211.5,19.3c0,2.6,1.6,4.5,4.5,4.5,2.2,0,3.3-.6,4.6-1.9l3.1,3c-2.1,2.1-4.1,3.2-7.7,3.2-4.8,0-9.4-2.2-9.4-10.4,0-6.6,3.6-10.4,8.9-10.4,5.7,0,8.9,4.1,8.9,9.7v2.3h-12.9Zm7.3-5.6c-.5-1.2-1.7-2.1-3.4-2.1s-2.9.9-3.4,2.1c-.3.7-.4,1.3-.5,2.2h7.7c0-.9-.1-1.5-.4-2.2"
            style={{ fill: "#4e4e50" }}
          />
          <path
            d="m235.8,28.2c-3.2,0-6.1-.3-8.7-2.9l3.3-3.3c1.7,1.7,3.9,1.9,5.4,1.9,1.8,0,3.6-.6,3.6-2.1,0-1-.5-1.7-2.1-1.9l-3.2-.3c-3.7-.3-5.9-1.9-5.9-5.7,0-4.2,3.7-6.5,7.9-6.5,3.2,0,5.8.6,7.8,2.4l-3.1,3.2c-1.2-1.1-3-1.4-4.7-1.4-2,0-2.9.9-2.9,1.9,0,.7.3,1.6,2.1,1.8l3.2.3c4,.4,6,2.5,6,6,0,4.4-3.9,6.6-8.7,6.6"
            style={{ fill: "#4e4e50" }}
          />
        </g>
      </svg>
    </div>
  )
}

const FooterLogo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 336 74.28">
      <g>
        <path
          d="m102.54,61.52c-1.13,1.13-2.97,1.83-4.95,1.83s-3.59-.54-4.92-2.03v9.25h-5.08v-27.8h4.92v1.91c1.4-1.56,2.93-2.15,5.08-2.15,1.99,0,3.82.7,4.95,1.84,2.03,2.03,2.07,5.5,2.07,8.55s-.04,6.56-2.07,8.58m-6.44-14.41c-3.04,0-3.44,2.5-3.44,5.82s.39,5.85,3.44,5.85,3.43-2.54,3.43-5.85-.39-5.82-3.43-5.82"
          fill="#fff"
        />
        <path
          d="m112,54.53c0,2.61,1.6,4.53,4.45,4.53,2.22,0,3.32-.63,4.61-1.92l3.08,3.01c-2.07,2.07-4.06,3.2-7.73,3.2-4.8,0-9.41-2.19-9.41-10.42,0-6.64,3.59-10.38,8.86-10.38,5.66,0,8.86,4.14,8.86,9.72v2.27h-12.72Zm7.26-5.66c-.55-1.21-1.68-2.11-3.4-2.11s-2.85.89-3.4,2.11c-.31.74-.43,1.29-.46,2.18h7.73c-.04-.89-.16-1.44-.47-2.18"
          fill="#fff"
        />
        <path
          d="m142.73,60.86c-1.25,1.33-3.31,2.5-6.33,2.5s-5.03-1.17-6.28-2.5c-1.84-1.91-2.31-4.22-2.31-7.92s.47-5.98,2.31-7.89c1.25-1.33,3.28-2.5,6.28-2.5s5.08,1.17,6.33,2.5c1.84,1.91,2.31,4.21,2.31,7.89s-.47,6.01-2.31,7.92m-3.95-12.84c-.58-.59-1.36-.9-2.38-.9s-1.76.31-2.34.9c-1.05,1.05-1.17,2.81-1.17,4.92s.12,3.9,1.17,4.95c.59.59,1.33.9,2.34.9s1.8-.31,2.38-.9c1.06-1.05,1.17-2.85,1.17-4.95s-.12-3.87-1.17-4.92"
          fill="#fff"
        />
        <path
          d="m163.35,61.52c-1.13,1.13-2.97,1.83-4.96,1.83s-3.59-.54-4.92-2.03v9.25h-5.08v-27.8h4.92v1.91c1.41-1.56,2.93-2.15,5.08-2.15,1.99,0,3.83.7,4.96,1.84,2.03,2.03,2.07,5.5,2.07,8.55s-.04,6.56-2.07,8.58m-6.44-14.41c-3.05,0-3.43,2.5-3.43,5.82s.39,5.85,3.43,5.85,3.43-2.54,3.43-5.85-.39-5.82-3.43-5.82"
          fill="#fff"
        />
        <path
          d="m174.44,63.12c-4.18,0-5.93-2.93-5.93-5.82v-21.98h5.08v21.67c0,1.22.5,1.84,1.79,1.84h1.96v4.29h-2.9Z"
          fill="#fff"
        />
        <path
          d="m183.82,54.53c0,2.61,1.6,4.53,4.45,4.53,2.23,0,3.32-.63,4.61-1.92l3.08,3.01c-2.07,2.07-4.06,3.2-7.73,3.2-4.81,0-9.41-2.19-9.41-10.42,0-6.64,3.59-10.38,8.86-10.38,5.66,0,8.86,4.14,8.86,9.72v2.27h-12.73Zm7.26-5.66c-.55-1.21-1.68-2.11-3.4-2.11s-2.85.89-3.4,2.11c-.32.74-.43,1.29-.47,2.18h7.73c-.04-.89-.16-1.44-.47-2.18"
          fill="#fff"
        />
      </g>
      <g>
        <path
          d="m205.73,50.2v12.92h-4.12v-12.92h-1.71v-3.14h1.71v-2.07c0-2.35,1.46-4.73,4.82-4.73h2.35v3.49h-1.62c-.98,0-1.43.54-1.43,1.5v1.81h3.05v3.14h-3.05Z"
          fill="#8c8a8d"
        />
        <path
          d="m221.98,61.28c-1.01,1.08-2.69,2.03-5.14,2.03s-4.1-.95-5.11-2.03c-1.49-1.55-1.87-3.43-1.87-6.44s.38-4.86,1.87-6.42c1.01-1.08,2.67-2.03,5.11-2.03s4.12.96,5.14,2.03c1.49,1.56,1.88,3.43,1.88,6.42s-.38,4.89-1.88,6.44m-3.2-10.44c-.48-.47-1.11-.73-1.93-.73s-1.43.26-1.91.73c-.86.86-.95,2.29-.95,4s.09,3.17.95,4.03c.48.48,1.08.73,1.91.73s1.45-.25,1.93-.73c.86-.86.95-2.32.95-4.03s-.09-3.14-.95-4"
          fill="#8c8a8d"
        />
        <path
          d="m235.56,51.09c-.64-.64-1.17-.98-2.19-.98-1.27,0-2.66.95-2.66,3.05v9.97h-4.13v-16.54h4.03v1.59c.79-.95,2.38-1.78,4.16-1.78,1.62,0,2.76.41,3.9,1.55l-3.11,3.14Z"
          fill="#8c8a8d"
        />
      </g>
      <g>
        <path
          d="m256.63,61.52c-1.13,1.13-2.96,1.83-4.96,1.83-2.15,0-3.67-.58-5.08-2.15v1.91h-4.92v-27.8h5.07v9.25c1.33-1.48,2.85-2.03,4.92-2.03s3.83.7,4.96,1.84c2.03,2.03,2.07,5.5,2.07,8.55s-.04,6.56-2.07,8.58m-6.44-14.41c-3.05,0-3.44,2.5-3.44,5.82s.39,5.85,3.44,5.85,3.44-2.54,3.44-5.85-.39-5.82-3.44-5.82"
          fill="#fff"
        />
        <path
          d="m263.42,35.17h5.2v4.14h-5.2v-4.14Zm.08,7.61h5.08v20.34h-5.08v-20.34Z"
          fill="#fff"
        />
        <polygon
          points="286.41 63.12 281.42 54.65 279.27 57.07 279.27 63.12 274.19 63.12 274.19 35.33 279.27 35.33 279.27 51.1 286.03 42.78 292.15 42.78 284.89 50.98 292.7 63.12 286.41 63.12"
          fill="#fff"
        />
        <path
          d="m299.08,54.53c0,2.61,1.6,4.53,4.45,4.53,2.22,0,3.31-.63,4.6-1.92l3.08,3.01c-2.07,2.07-4.06,3.2-7.73,3.2-4.8,0-9.41-2.19-9.41-10.42,0-6.64,3.59-10.38,8.87-10.38,5.66,0,8.86,4.14,8.86,9.72v2.27h-12.73Zm7.26-5.66c-.55-1.21-1.68-2.11-3.4-2.11s-2.85.89-3.4,2.11c-.31.74-.44,1.29-.47,2.18h7.73c-.04-.89-.16-1.44-.47-2.18"
          fill="#fff"
        />
        <path
          d="m323.44,63.36c-3.2,0-6.09-.35-8.67-2.93l3.32-3.32c1.68,1.68,3.86,1.91,5.43,1.91,1.76,0,3.59-.58,3.59-2.11,0-1.02-.55-1.72-2.15-1.87l-3.2-.31c-3.67-.35-5.94-1.95-5.94-5.7,0-4.22,3.72-6.48,7.85-6.48,3.16,0,5.82.55,7.77,2.38l-3.12,3.17c-1.17-1.06-2.97-1.37-4.73-1.37-2.03,0-2.89.93-2.89,1.95,0,.74.31,1.6,2.11,1.76l3.2.32c4.02.39,6.05,2.54,6.05,5.97,0,4.49-3.83,6.64-8.63,6.64"
          fill="#fff"
        />
      </g>
      <rect
        x="1.39"
        y=".83"
        width="68.82"
        height="72.31"
        rx="6.58"
        ry="6.58"
        fill="#fff"
      />
      <path
        d="m3.77,52.16v13.03c0,3.01,2.43,5.43,5.43,5.43h53.36c3,0,5.44-2.43,5.44-5.43v-13.03H3.77Zm43.9,7.71c-3.08,2.9-7.23,4.68-11.78,4.68s-8.7-1.78-11.78-4.68l-.16-.15,1.88-1.88.15.14c2.61,2.42,6.08,3.91,9.91,3.91s7.3-1.49,9.91-3.91l.15-.14,1.89,1.88-.17.15Z"
        fill="#e12b27"
      />
      <path
        d="m68,49.47h-13.81c3.4-1.49,5.78-4.89,5.78-8.85,0-5.33-4.33-9.66-9.66-9.66-.9,0-1.76.12-2.59.35l-2.52-6.92h3.2c.65.01,1.17.54,1.17,1.2s-.54,1.2-1.2,1.2h-.17v1.36h.17c1.42,0,2.56-1.15,2.56-2.57s-1.12-2.55-2.53-2.56h-5.19l1.39,3.83h-14.85l-.65-1.97c.17-.04.34-.09.51-.15.66-.26.77-.26,1.42-.26s1.32-.1,1.32-.1c0,0-.41-1.17-1.62-1.12-.88.03-2.75.41-3.72.3-.97-.11-2.09-.36-2.29.2-.21.56-.1.82.92.97.99.15,1.36,0,1.99.14l.86,2.61-2.84,4.59c-1.35-.71-2.87-1.11-4.5-1.11-5.33,0-9.66,4.33-9.66,9.66,0,3.96,2.38,7.36,5.78,8.85H3.77V8.79c0-3,2.43-5.44,5.43-5.44h53.36c3,0,5.44,2.44,5.44,5.44v40.68Zm-27.36-8.85c0-3.95,2.36-7.34,5.77-8.85l-.98-2.66-11.08,11.71c-.29.3-.7.49-1.14.49h-2.4c-.26,3.66-2.55,6.74-5.75,8.15h21.36c-3.4-1.49-5.78-4.89-5.78-8.85m-14.85-6.13l-3.37,5.42s0,0,0,0h6.38c-.17-1.85-.98-3.49-2.21-4.73-.25-.26-.52-.49-.81-.7m1.06-1.69c2.24,1.63,3.75,4.2,3.96,7.12h1.81l-3.54-10.72-2.23,3.6Zm-5.74,9.31c-.83,0-1.5-.67-1.5-1.49s.67-1.5,1.5-1.5c.05,0,.11,0,.16,0l3.34-5.38c-1.03-.53-2.2-.82-3.44-.82-2.12,0-4.03.85-5.43,2.24-1.39,1.4-2.25,3.31-2.25,5.43s.86,4.03,2.25,5.43c1.4,1.39,3.31,2.25,5.43,2.25s4.04-.85,5.43-2.25c1.23-1.24,2.05-2.89,2.21-4.73h-6.38c-.25.48-.75.8-1.32.8m34.62-6.93c-1.39-1.39-3.31-2.25-5.43-2.25-.65,0-1.29.09-1.9.24l2.17,5.97c.72.11,1.27.73,1.27,1.47,0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5c0-.39.15-.75.4-1.02l-2.16-5.95c-.82.38-1.57.9-2.21,1.54-1.39,1.4-2.25,3.31-2.25,5.43s.86,4.03,2.25,5.43c1.39,1.39,3.31,2.24,5.43,2.24s4.03-.85,5.43-2.24c1.39-1.4,2.25-3.3,2.25-5.43s-.86-4.03-2.25-5.43m-21.82,4.2v.02s10.42-11.16,10.42-11.16h-14.1l3.68,11.15Z"
        fill="#1da0db"
      />
    </svg>
  )
}

export { Logo }
export { WordMark }
export { FooterLogo }
